<template>
  <Nav></Nav>
  <main class="projects">
    <back-button></back-button>
    <h1 v-if="organization">{{ organization.name }} Profiles</h1>
    <h1 v-else>Profiles</h1>
    <nav class="menu" v-if="organization  && currentAccount.role >= AccountRole.ORGANIZATION_ADMIN">
      <router-link :to="{ name: 'Organization', org_slug: organization.slug }">
        <font-awesome-icon icon="edit" />
        <span>編集</span>
      </router-link>
    </nav>
    <Table :data="data" :headers="headers" :linkCols="linkCols" :newUri="newUri" :newCaption="newCaption"></Table>
  </main>
  <Dialog ref="error" class="dialog">
    <h4 class="title">Error</h4>
    <div class="message">
      <p class="text">{{ error.message }}</p>
    </div>
    <div class="action">
      <button class="btn btn-light" @click="errorClose">Close</button>
    </div>
  </Dialog>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import BackButton from '@/components/BackButton.vue';
import Dialog from '@/components/Dialog.vue';
import Nav from '@/components/Nav.vue';
import Table from '@/components/Table.vue';
import { Organization, OrganizationData } from '@/lib/organization';
import { Project } from '@/lib/project';
import { Account, AccountData,AccountRole } from '@/lib/account';

export default defineComponent({
  name: 'Projects',
  components: {
    BackButton,
    Dialog,
    Nav,
    Table,
  },
  data() {
    return {
      orgSlug: this.$route.params.org_slug as string,
      organization: null as OrganizationData | null,
      data: [] as string[][],
      linkCols: [] as string[][],
      headers: [] as string[],
      newUri: './projects/new',
      newCaption: '新しいプロファイル',
      currentAccount:  {
        slug: '',
        email: '',
        first_name: '',
        last_name: '',
        password: '',
        role: 0,
        created: undefined,
        updated: undefined,
      } as AccountData,
      error: {
        message: '',
        back: false,
      },
      AccountRole,
    };
  },
  async mounted() {
    try {
      const org = new Organization(this.orgSlug);
      const ac = new Account();
      this.currentAccount = await ac.getByToken();
      const data = await org.get();
      if (data) {
        this.organization = data;
      } else {
        throw new Error('この組織は見つかりませんでした。');
      }
    } catch (e) {
      if (e instanceof Error) {
        this.error.message = e.message;
        this.error.back = true;
        (this.$refs.error as InstanceType<typeof Dialog>)?.open();
      }
      console.warn(e);
      return;
    }
    try {
      const prj = new Project(this.orgSlug);
      const data = await prj.all();
      if (data) {
        for (const row of data) {
          this.data.push([row.name]);
          this.linkCols.push([`./projects/${row.slug}`]);
        }
        this.headers.push('プロファイル');
      }
    } catch (e) {
      if (e instanceof Error) {
        this.error.message = e.message;
        this.error.back = true;
        (this.$refs.error as InstanceType<typeof Dialog>)?.open();
      }
      console.warn(e);
    }
  },
  methods: {
    errorClose() {
      (this.$refs.error as InstanceType<typeof Dialog>)?.close();
      this.error.back && this.$router.back();
    },
  },
});
</script>

<style lang="scss" scoped>
@use '@/assets/const.scss' as *;
@use '@/assets/dialog.scss' as *;

.projects .menu {
  display: flex;
  flex-wrap: wrap;
  margin: 0 0.5rem 10px;
  @media (min-width: $tablet) {
    margin: 0 20px 10px;
  }
  @media (min-width: $desktop) {
    margin: 0 40px 10px;
  }

  a {
    margin-right: 10px;
    text-decoration: none;
    color: inherit;
    &:last-child {
      margin-right: 0;
    }

    span {
      margin-left: 5px;
    }
  }
}

.dialog {
  @include dialog();
}
</style>
